import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-semibold text-foreground-900">
                Vigorbuy<span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              Your ultimate resource hub for discovering curated products, verified QC photos, 
              and expert shopping guides. Navigate the Vigorbuy Spreadsheet with confidence 
              and shop smarter.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <a href="#categories" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Categories</a>
              <a href="#articles" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Latest Articles</a>
              <a href="#what-is" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">About Vigorbuy Spreadsheet</a>
              <Link to="/blog/vigorbuy-spreadsheet-safety-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Safety Guide</Link>
              <Link to="/blog/vigorbuy-spreadsheet-category-deep-dive" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Category Deep Dive</Link>
              <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">FAQ</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Popular Guides</h4>
            <div className="flex flex-col gap-2">
              <Link to="/blog/vigorbuy-spreadsheet-ultimate-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Complete Guide</Link>
              <Link to="/blog/vigorbuy-spreadsheet-beginners-first-steps" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Beginners First Steps</Link>
              <Link to="/blog/vigorbuy-spreadsheet-qc-photos-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">QC Photos Guide</Link>
              <Link to="/blog/vigorbuy-spreadsheet-international-buyer-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">International Buyer Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">Main Website</a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} Vigorbuy Spreadsheet Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Privacy Policy</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}